<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D9S6kC/tc-custom/9781418574000.jpg?1706124140710" alt="This image is the cover for the book Sweetwater Gap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweetwater Gap
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Life doesn’t give do-overs. She’s sure of it. But then she goes home again.</b></p><p>Josie Mitchell’s sister Laurel thinks she’s come home to pitch in with the apple harvest and save the family orchard. Her brother-in-law Nate thinks she’s there to talk the overworked, very pregnant Laurel into finally selling the family business. The orchard’s new manager Grady Mackenzie just thinks she’s trouble with a capital T. They’re all right . . . and all wrong. Because no one really knows what drove Josie from home in the first place. Why she’s never come home before, even for her own father’s funeral. Why she pushes herself so hard . . . and what she’s running from. And nobody, not even Josie, is prepared for the surprising new fruit she’ll find on her last trip home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Hunter
      </h2>
      
      <p class="authorDescription body article"><P>Denise Hunter is the internationally published, bestselling author of more than forty books, three of which have been adapted into original Hallmark Channel movies. She has won the Holt Medallion Award, the Reader&rsquo;s Choice Award, the Carol Award, the Foreword Book of the Year Award, and is a RITA finalist. When Denise isn&rsquo;t orchestrating love lives on the written page, she enjoys traveling with her family, drinking chai lattes, and playing drums. Denise makes her home in Indiana, where she and her husband raised three boys and are now enjoying an empty nest and three beautiful grandchildren. DeniseHunterBooks.com; Facebook: @AuthorDeniseHunter; Twitter: @DeniseAHunter; Instagram: @deniseahunter.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1389ef17